export enum DATE_FORMAT {
    DD_MM_YYYY = "dd.MM.yyyy",
    YYYY_MM_DD = "yyyy-MM-dd",
    MM_DD_YYYY = "MM/dd/yyyy",
    DD_MM_YYYY_slash = "dd/MM/yyyy",
}

export const DATE_FORMAT_OPTIONS = [
    { value: DATE_FORMAT.DD_MM_YYYY, label: `"day_short"."month_short"."year_long"` },
    { value: DATE_FORMAT.YYYY_MM_DD, label: `"year_long"-"month_short"-"day_short"` },
    { value: DATE_FORMAT.MM_DD_YYYY, label: `"month_short"/"day_short"/"year_long"` },
    { value: DATE_FORMAT.DD_MM_YYYY_slash, label: `"day_short"/"month_short"/"year_long"` },
];

// Date format options for all locales
export const DATE_FORMAT_OPTIONS_ALL_LOCALES = {
    en: DATE_FORMAT_OPTIONS,
    es: DATE_FORMAT_OPTIONS,
    tr: DATE_FORMAT_OPTIONS,
    de: DATE_FORMAT_OPTIONS,
    ar: DATE_FORMAT_OPTIONS,
};

export enum TIME_FORMAT {
    TWENTY_FOUR_HOURS = "HH:mm",
    TWELVE_HOURS = "hh:mm a",
}

export const TIME_FORMAT_OPTIONS = [
    { value: TIME_FORMAT.TWENTY_FOUR_HOURS, label: "24_hours_format" },
    { value: TIME_FORMAT.TWELVE_HOURS, label: "am_pm_format" },
];

// Time format options for all locales
export const TIME_FORMAT_OPTIONS_ALL_LOCALES = {
    en: TIME_FORMAT_OPTIONS,
    es: TIME_FORMAT_OPTIONS,
    tr: TIME_FORMAT_OPTIONS,
    de: TIME_FORMAT_OPTIONS,
    ar: TIME_FORMAT_OPTIONS,
};
